import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./CreditForm.module.scss";
import Header from "../../../components/Header/Header";
import validator from "../../../utils/validator";
import addCommas from "../../../utils/amountFormat";
import customStyles from "../../../utils/select-custom-styles";
import ccpic from "../../../resources/images/CC.svg";
import analyticsService from "../../../services/analytics/analyticsService";
import useGetSession from "../../../hooks/useGetSession";

function CreditForm(props: any) {
  const navigate = useNavigate();
  const location = useLocation();
  let dumble = new analyticsService();
  const [getSession] = useGetSession();
  const [bfcemail, setBfcemail] = useState<string>();

  // TO-DO: get remit amount
  // const {
  //   remitAmount,
  // } = location.state as any;

  const [payAmt, setPayAmt] = useState({
    value: "",
    error: "",
    touched: false,
  });
  const [fname, setFname] = useState({
    value: "",
    error: "",
    touched: false,
  });
  const [lname, setLname] = useState({
    value: "",
    error: "",
    touched: false,
  });
  const [cc, setCc] = useState({
    value: "",
    error: "",
    touched: false,
  });
  const [ccType, setCcType] = useState<string>("");
  const [cbsCardType, setCbsCardType] = useState<string>("");
  const [expMonth, setExpMonth] = useState<string>("");
  const [expYear, setExpYear] = useState<string>("");
  const [cvv, setCvv] = useState({
    value: "",
    error: "",
    touched: false,
  });

  const [selectError, setSelectError] = useState({
    month: false,
    year: false,
  });
  const month = new Date().getMonth();
  const year = new Date().getFullYear();
  let years = Array.from(new Array(20), (val, index) =>
    (index + year).toString()
  );
  const { version } = props;

  const selectMonth = () => {
    let counter = 1;
    if (parseInt(expYear, 10) === year) {
      counter = month + 1;
    }
    const allMonths = [];
    while (counter <= 12) {
      const x = {
        label: counter,
        value: counter.toString().padStart(2, "0"),
      };
      allMonths.push(x);
      counter += 1;
    }
    return allMonths;
  };

  const selectYear = () => {
    let counter = 0;
    const allYears = [];
    if (parseInt(expMonth, 10) <= month) {
      years = years.slice(1, years.length);
    }
    while (counter < years.length) {
      const x = {
        label: years[counter],
        value: years[counter],
      };
      allYears.push(x);
      counter += 1;
    }
    return allYears;
  };

  const getSessionInfo = async () =>{
    const { data, error } = await getSession();
    if (error){
      console.log(error);
      return;
    } else if (data != null) {
      setBfcemail(data.chairperson.email);
    }
  }

  const handleInput = (type: string, input: any, field: object) => {
    const newField: any = { ...field };
    newField[type] = input;
    return newField;
  };

  // analytics
  useEffect(() => {
    dumble.initDumblePage("Payment Portal:Credit Card:Payment Info");
  }, [])

  useEffect(() => {
    getSessionInfo();
  }, [])

  useEffect(() => {
    if (version === "creditcard"){
      setPayAmt(
        handleInput(
          "error",
          validator(payAmt.value, ["required", "payment"]),
          payAmt
        )
      );
    } else{
      setPayAmt(
        handleInput(
          "touched", true, payAmt
        )
      )
    }
  }, [payAmt.value]);

  useEffect(() => {
    setFname(
      handleInput("error", validator(fname.value, ["required", "name"]), fname)
    );
  }, [fname.value]);

  useEffect(() => {
    setLname(
      handleInput("error", validator(lname.value, ["required", "name"]), lname)
    );
  }, [lname.value]);

  useEffect(() => {
    setCc(
      handleInput("error", validator(cc.value, ["required", "cclength"]), cc)
    );
    if (
      (cc.value.length === 17 && cc.value[0] === "3") ||
      cc.value.length === 19
    ) {
      const x = cc.value.replaceAll(" ", "");
      setCc(handleInput("error", validator(x, ["credit"]), cc));
    }
  }, [cc.value]);

  useEffect(() => {
    let creditType = "";
    let cbsCT = "";
    if (cc.value.length > 0) {
      const firstNum = cc.value[0];
      if (firstNum === "4") {
        creditType = "Visa";
        cbsCT = "001";
      } else if (firstNum === "5" || firstNum === "2") {
        creditType = "Mastercard";
        cbsCT = "002";
      } else if (firstNum === "6") {
        creditType = "Discover";
        cbsCT = "004";
      } else if (firstNum === "3") {
        creditType = "American Express";
        cbsCT = "003";
      }
    }
    setCcType(creditType);
    setCbsCardType(cbsCT);
  }, [cc.value]);

  useEffect(() => {
    // needed to activate the error messages for the Select components
    console.log("Setting Select errors.");
  }, [selectError, 
    payAmt.touched,
    fname.touched,
    lname.touched,
    cc.touched,
    cvv.touched]);

  const callSpacing = (input: string) => {
    let postSpacing = "";
    // only if they're accepted cards
    if (input[0] === "3"){
      const x = input.replace(/[^0-9]/gi, "").match(/(\d{0,4})(\d{0,6})(\d{0,5})/);
      postSpacing = x![1] + (x![2] ? ' ' + x![2] : '') + (x![3] ? ' ' + x![3] : '');
    } else {
      const x = input.replace(/[^0-9]/gi, "").match(/(\d{0,4})(\d{0,4})(\d{0,4})(\d{0,4})/);
      postSpacing = x![1] + (x![2] ? ' ' + x![2] : '') + (x![3] ? ' ' + x![3] : '') + (x![4] ? ' ' + x![4] : ''); 
    }
    return postSpacing;
  };

  const handleMonth = (e: any) => {
    setExpMonth(e.value);
    if (expYear) setSelectError(handleInput("year", false, selectError));
  };

  const handleYear = (e: any) => {
    setExpYear(e.value);
    if (expMonth) setSelectError(handleInput("month", false, selectError));
  };

  const cvvType = () => {
    if (ccType === "American Express") return 4;
    if (ccType !== "") return 3;
    return 4;
  };

  useEffect(() => {
    setCvv(handleInput("error", validator(cvv.value, ["required"]), cvv));
    if (cvv.value.length !== cvvType()) {
      if (cc.value !== "") {
        setCvv(handleInput("error", "Invalid: Please enter valid cvv", cvv));
      }
    }
  }, [cvv.value, cc.value]);

  const displayError = (input: any) => {
    if (input.error !== "") {
      return <div className={styles.errorMessage}>{input.error}</div>;
    }
    return null;
  };

  const setTouched = (field: string, input: any) => {
    const touch = field;
    const x = input;
    return handleInput(touch, true, x);
  };

  const showHeader = () => {
    if (version === "creditcard") {
      return <Header name="Credit Card Payment" redirect="/" />;
    }
    return null;
  };

  const paymentInfo = () => {
    if (version === "creditcard") {
      return (
        <div className={styles.inputContainer}>
          <br/>
          <label htmlFor="paymentAmt">
            Payment Amount:
            <input
              type="text"
              value={`$ ${payAmt.value}`}
              maxLength={10}
              onChange={(e) =>
                setPayAmt(
                  handleInput(
                    "value",
                    addCommas(e.target.value),
                    payAmt
                  )
                )
              }
              onBlur={() => setPayAmt(setTouched("touched", payAmt))}
              aria-label="paymentAmt"
              id="paymentAmt"
            />
            {payAmt.error !== "" && payAmt.touched
              ? displayError(payAmt)
              : null}
          </label>
        </div>
      );
    }
    return (
      <div className={styles.payment}>
        <img src={ccpic} alt="credit card" className={styles.svgCC} />
        <h3>Payment Information</h3>
        <h5>Balance due: $amount</h5>
        <br />
      </div>
    );
  };

  const isTouched = () => {
    if (
      payAmt.touched &&
      fname.touched &&
      lname.touched &&
      cc.touched &&
      cvv.touched
    ) {
      console.log("Every field has been touched");
      return true;
    } else {
      console.log("There's a field or fields that hasn't been touched");
      return false;
    }
  };

  const disableButton = () => {
    if (
      fname.error ||
      lname.error ||
      cc.error ||
      !expYear ||
      !expMonth ||
      cvv.error ||
      !isTouched()
    ) return true
    else {
      if ((version === "creditcard") && payAmt.error && payAmt.touched) return true;
      return false;
    }
  };

  const touchAll = () => {
      setPayAmt(handleInput("touched", true, payAmt));
      setFname(handleInput("touched", true, fname));
      setLname(handleInput("touched", true, lname));
      setCc(handleInput("touched", true, cc));
      setCvv(handleInput("touched", true, cvv));
      setSelectError({
        month: true,
        year: true,
      });
  };

  const redirectToReview = (e: any) => {
    touchAll();
    e.preventDefault();
    if (!disableButton()) {
      const cred = cc.value.toString().replaceAll(" ", "");
      navigate(version === "creditcard" ? "/creditcardpayment/review.html" : "/remitpayment/review.html", {
        state: {
          paymentAmt: payAmt.value,
          firstName: fname.value,
          lastName: lname.value,
          cardNumber: cred,
          cardCvn: cvv.value,
          cardType: ccType,
          cbsCardType: cbsCardType,
          cardExpiration: `${expMonth}-${expYear}`,
          bfcemail: bfcemail,
        },
      });
    }
  };


  return (
    <div className={styles.CreditForm} data-testid="CreditPayment">
      {showHeader()}
      <div className={styles.CreditFormContainer}>
        <br />
        <form
          className={
            version === "creditcard"
              ? styles.form
              : `${styles.form} ${styles.formsize}`
          }
        >
          {paymentInfo()}
          <div className={styles.ccName} >
            <div className={styles.inputContainer}>
              <label htmlFor="fName">
                First Name:
                <input
                  type="text"
                  value={fname.value}
                  maxLength={30}
                  onChange={(e) =>
                    setFname(
                      handleInput(
                        "value",
                        e.target.value.replace(/[^a-zA-Z0-9 -]/, ""),
                        fname
                      )
                    )
                  }
                  onBlur={() => setFname(setTouched("touched", fname))}
                  aria-label="fName"
                  id="fName"
                />
                {fname.error !== "" && fname.touched
                  ? displayError(fname)
                  : null}
              </label>
            </div>
            <div className={styles.inputContainer}>
              <label htmlFor="lName">
                Last Name:
                <input
                  type="text"
                  value={lname.value}
                  maxLength={30}
                  onChange={(e) =>
                    setLname(
                      handleInput(
                        "value",
                        e.target.value.replace(/[^a-zA-Z0-9 -]/, ""),
                        lname
                      )
                    )
                  }
                  onBlur={() => setLname(setTouched("touched", lname))}
                  aria-label="lName"
                  id="lName"
                />
                {lname.error !== "" && lname.touched
                  ? displayError(lname)
                  : null}
              </label>
            </div>
          </div>
          <div className={styles.inputContainer}>
            <label htmlFor="ccNum">
              Credit Card Number:
              <input
                type="text"
                value={cc.value}
                maxLength={ccType !== "American Express" ? 19 : 17}
                onChange={(e) =>
                  setCc(
                    handleInput(
                      "value",
                      callSpacing(e.target.value),
                      cc
                    )
                  )
                }
                onBlur={() => setCc(setTouched("touched", cc))}
                aria-label="ccNum"
                id="ccNum"
              />
              {cc.error !== "" && cc.touched ? displayError(cc) : null}
            </label>
          </div>
          <div className={styles.ccExpiration}>
            <div className={styles.date}>
              Expiration:
              <div className={styles.expiration}>
                <div className={styles.months}>
                  <Select
                    options={selectMonth()}
                    styles={customStyles}
                    onChange={handleMonth}
                    onBlur={() =>
                      setSelectError(setTouched("month", selectError))
                    }
                    aria-label="expmonth"
                    id="expMonth"
                    placeholder="Month"
                  />
                  {expMonth === "" && selectError.month ? (
                    <div className={styles.errorMessage}>
                      Blank: This field is required
                    </div>
                  ) : null}
                </div>
                <div className={styles.years}>
                  <Select
                    options={selectYear()}
                    styles={customStyles}
                    onChange={handleYear}
                    onBlur={() =>
                      setSelectError(setTouched("year", selectError))
                    }
                    aria-label="expyear"
                    id="expYear"
                    placeholder="Year"
                  />
                  {expYear === "" && selectError.year ? (
                    <div className={styles.errorMessage}>
                      Blank: This field is required
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
            <div className={`${styles.inputContainer} ${styles.cvv}`}>
              <label htmlFor="cvv">
                Security Code:
                <input
                  type="text"
                  value={cvv.value}
                  maxLength={cvvType()}
                  onChange={(e) =>
                    setCvv(
                      handleInput(
                        "value",
                        e.target.value.replace(/[^0-9]/gi, ""),
                        cvv
                      )
                    )
                  }
                  onBlur={() => setCvv(setTouched("touched", cvv))}
                  aria-label="cvv"
                  id="cvv"
                />
                {cvv.error !== "" && cvv.touched ? displayError(cvv) : null}
              </label>
            </div>
          </div>
          <button
            type="submit"
            onClick={
              redirectToReview
            }
            id="submitButton"
            disabled={false}
          >
            {" "}
            REVIEW PAYMENT{" "}
          </button>
        </form>
      </div>
    </div>
  );
}

export default CreditForm;
